import React from 'react';
import { motion } from 'framer-motion';
import { Apple, Play } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-32 relative overflow-hidden" data-id="element-34">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl aspect-square bg-tatan-blue/20 blur-[120px] rounded-full pointer-events-none" data-id="element-35" />

      <div className="max-w-4xl mx-auto px-6 text-center relative z-10" data-id="element-36">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-5xl md:text-7xl font-black tracking-tighter mb-8 text-balance" data-id="element-37">
          Ready to design your next tattoo?
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-xl text-gray-400 mb-12 max-w-2xl mx-auto" data-id="element-38">
          Join over 1 million users turning their ideas into incredible ink.
          Download TATAN today.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="flex flex-wrap justify-center gap-4" data-id="element-39">
          <a href="https://apps.apple.com/us/app/tatan-ai-tattoo-design-maker/id6763227385" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 bg-white text-black px-8 py-4 rounded-2xl font-bold hover:bg-gray-100 transition-transform hover:scale-105 active:scale-95" data-id="element-40">
            <Apple className="w-7 h-7" data-id="element-41" />
            <div className="text-left" data-id="element-42">
              <div className="text-xs leading-none text-gray-600 font-semibold mb-1" data-id="element-43">
                Download on the
              </div>
              <div className="text-base leading-none" data-id="element-44">App Store</div>
            </div>
          </a>
          <div aria-disabled="true" className="flex items-center gap-3 bg-zinc-900/60 text-gray-400 px-8 py-4 rounded-2xl font-bold border border-white/10 cursor-not-allowed" data-id="element-45">
            <Play className="w-7 h-7" data-id="element-46" />
            <div className="text-left" data-id="element-47">
              <div className="text-xs leading-none text-gray-500 font-semibold mb-1" data-id="element-48">
                Google Play
              </div>
              <div className="text-base leading-none" data-id="element-49">Coming Soon</div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}